var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18335 9.68332L10.2959 5.57082L9.47919 4.75416L6.18335 8.04999L4.52085 6.38749L3.70419 7.20416L6.18335 9.68332ZM7.00002 12.8333C6.19308 12.8333 5.43474 12.6802 4.72502 12.3739C4.0153 12.0677 3.39794 11.6521 2.87294 11.1271C2.34794 10.6021 1.93231 9.98471 1.62606 9.27499C1.31981 8.56527 1.16669 7.80693 1.16669 6.99999C1.16669 6.19305 1.31981 5.43471 1.62606 4.72499C1.93231 4.01527 2.34794 3.39791 2.87294 2.87291C3.39794 2.34791 4.0153 1.93228 4.72502 1.62603C5.43474 1.31978 6.19308 1.16666 7.00002 1.16666C7.80696 1.16666 8.5653 1.31978 9.27502 1.62603C9.98474 1.93228 10.6021 2.34791 11.1271 2.87291C11.6521 3.39791 12.0677 4.01527 12.374 4.72499C12.6802 5.43471 12.8334 6.19305 12.8334 6.99999C12.8334 7.80693 12.6802 8.56527 12.374 9.27499C12.0677 9.98471 11.6521 10.6021 11.1271 11.1271C10.6021 11.6521 9.98474 12.0677 9.27502 12.3739C8.5653 12.6802 7.80696 12.8333 7.00002 12.8333Z",
    fill: "#0F9918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreeen);
export default __webpack_public_path__ + "static/media/check-greeen.90205abe9536af7244b46293f443b88b.svg";
export { ForwardRef as ReactComponent };